import React, { useState } from 'react';
import './dropdown.component.css';

const Dropdown = React.forwardRef((props, ref) => {
  const [optionsState, setOptionsState] = useState(false);
  const [selectedIdx, setSelectedIdx] = useState(0);
  const optionsLength = props.options.length;

  const handleKeyboardNav = (e) => {
    e.stopPropagation();
    switch (e.keyCode) {
      case 40:
        e.preventDefault();
        if (selectedIdx !== optionsLength - 1) {
          setSelectedIdx(selectedIdx + 1);
        }
        break;
      case 38:
        e.preventDefault();
        if (selectedIdx > 0) {
          setSelectedIdx(selectedIdx - 1);
        }
        break;
      case 13:
        e.preventDefault();
        if (!optionsState) {
          setOptionsState(true);
        } else {
          props.setSelected(props.options[selectedIdx]);
        }
        setOptionsState(!optionsState);
        break;
      default:
        break;
    }
  };

  return (
    <div
      className={`c-dropdown cont ${props.containerClass}`}
      onClick={() => setOptionsState(!optionsState)}
      onKeyDown={(e) => handleKeyboardNav(e)}
      onBlur={() => {
        setOptionsState(false);
        if (props.onBlur) {
          props.onBlur();
        }
      }}
      tabIndex="0"
      ref={ref}
    >
      <input
        type="text"
        value={props.selected.toLowerCase()}
        placeholder={props.placeholder}
        disabled
      />
      <ul
        className={`options ${optionsState ? 'd-block' : 'd-none'}`}
        style={props.optionsPosition}
      >
        {props.options.map((option, idx) => {
          return (
            <li
              key={option}
              className={`option ${idx === selectedIdx && 'active'}`}
              onClick={() => {
                props.setSelected(option);
              }}
              onMouseOver={() => setSelectedIdx(idx)}
            >
              {option.toLowerCase()}
            </li>
          );
        })}
      </ul>
    </div>
  );
});

export default Dropdown;
